import { NoticePage } from './NoticePage'
import { CREDIT_REPORTING_TITLE, CREDIT_REPORTING_CONTENT } from './disclosureContent'

export function CreditReportingBureauNotice() {
  return (
    <NoticePage
      title={CREDIT_REPORTING_TITLE}
      content={CREDIT_REPORTING_CONTENT}
      linkType="terms_credit"
    />
  )
}
